import styled from 'styled-components'
import {colors} from '../../styles/theme'

export const DailyProgressBox = styled.div`
  display: flex;
  gap: 32px;
  align-items: flex-start;
  padding: 32px;
  justify-content: center;

  && img {
    cursor: pointer;
  }

  @media only screen and (max-width: 1572px) {
    gap: 16px;
  }
`

export const DayTrackerList = styled.div`
  display: flex;
`

export const DayTrackerItem = styled.div`
  display: flex;
  flex-flow: column;
  gap: 4px;
  align-items: center;
  cursor: pointer;
`

export const DayTrackerText = styled.span<{$isComplete?: boolean}>`
  font-size: 12px;
  font-weight: bold;

  ${({$isComplete}) =>
    $isComplete ? `color:${colors.bksGray50};` : `color:${colors.bksGray80};`}
`

export const DayTrackerImage = styled.div<{
  itemPosition: 'first' | 'last' | 'center'
  itemStatus: 'track' | 'complete' | 'behind' | 'inactive'
  $isActive?: boolean
}>`
  gap: 8px;
  padding: 0 24px;
  height: 24px;
  width: 24px;
  position: relative;
  z-index: 0;

  @media only screen and (max-width: 1540px) {
    padding: 0 16px;
  }

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: calc(50% - 2.5px);
    height: 5px;
    z-index: -1;
  }

  &::before {
    left: 0;
    width: 50%;

    ${({itemStatus}) =>
      itemStatus !== 'inactive'
        ? `background-color: ${colors.blue1};`
        : `background-color: #D9D9D9;`}
    ${({itemPosition}) =>
      itemPosition === 'first' ? `border-radius: 999px 0 0 999px;` : null}
  }

  &::after {
    right: 0;
    width: 50%;

    ${({itemStatus}) =>
      itemStatus !== 'inactive' && itemStatus !== 'track'
        ? `background-color: ${colors.blue1};`
        : `background-color: #D9D9D9;`}

    ${({itemPosition}) =>
      itemPosition === 'last' ? `border-radius: 0 999px 999px 0;` : null}
  }
`

export const AlertCount = styled.div<{oriented: 'right' | 'left'}>`
  position: absolute;
  color: #fff;
  background: ${colors.crimsonRed};
  font-size: 8px;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({oriented}) => (oriented === 'left' ? `left:-6px;` : `right: -6px;`)}
  top: 6px;
`

export const ImageButton = styled.button`
  border: 0;
  background: none;
  margin: 0;
  padding: 0;
`
